type BreadcrumbsLabelsType = Record<string, string>;

export const breadcrumbsLabels: BreadcrumbsLabelsType = {
  'mvp-building': 'MVP Building',
  'no-code': 'No-Code',
  'product-discovery': 'Product Discovery',
  design: 'Product Design',
  development: 'Development',
  industries: 'Industries',
  'healthcare-industry': 'Healthcare Industry',
  'edtech-industry': 'EdTech Industry',
  'ai-industry': 'AI Industry',
  'fintech-industry': 'FinTech Industry',
  'travel-industry': 'Travel Industry',
};
